/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
const kid_number_medium = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeWidth={1.5}
      d="M22 3H2a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h20a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1Z"
    />
    <path
      fill="#000"
      d="M7.24 11.733 9.67 15H7.969l-1.53-2.268-.279.351V15H4.81V8.7h1.35v2.53L8.059 8.7H9.67l-2.43 3.033ZM11.149 15V8.7h1.35V15h-1.35Zm5.081-6.3c.648 0 1.212.132 1.692.396.486.258.861.624 1.125 1.098.264.474.396 1.026.396 1.656 0 .63-.132 1.182-.396 1.656a2.776 2.776 0 0 1-1.125 1.107c-.48.258-1.044.387-1.692.387h-1.665V8.7h1.665Zm-.126 5.22c.612 0 1.092-.186 1.44-.558.348-.372.522-.876.522-1.512s-.174-1.14-.522-1.512c-.348-.372-.828-.558-1.44-.558h-.189v4.14h.19Z"
    />
  </svg>
)
export default kid_number_medium
